<div class="relative w-full">
  <img src="/history/history-bg-mo.png" alt="top background" class="w-full flex lg:hidden" />
  <img src="/history/history-bg-pc.png" alt="top background" class="w-full hidden lg:flex" />

  <div class="absolute inset-0 flex flex-col justify-center gap-3 pt-14 px-4 lg:px-0 lg:container">
    <h1 class="text-white text-2xl lg:text-4xl font-bold">마이스 좋은공간</h1>
    <p class="text-zinc-300 font-medium">Introduction to Good Space</p>
  </div>
</div>

<app-value />
<app-vision />
<app-business />
<app-philosophy />
